import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types';
import Modal from 'react-bootstrap/Modal';
import Box from '@mui/material/Box';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import TableSortLabel from '@mui/material/TableSortLabel';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import ArrowForwardIosSharpIcon from '@mui/icons-material/ArrowForwardIosSharp';
import ArrowBackIosNewSharpIcon from '@mui/icons-material/ArrowBackIosNewSharp';
import redCross from "../../../assets/images/CommonComponent/redCross.svg";
import Paper from '@mui/material/Paper';
import { visuallyHidden } from '@mui/utils';
import Divider from '@mui/material/Divider';
import styled from '@emotion/styled';
import Select from "react-select";
import { FormGroup, } from "reactstrap";
import { createNotification } from '../../../Config/NotificationToast';
import { getContentsList } from '../../../redux/actions/ContentManagementAction/VideoPodcasts/VideoPodcastsAction';
import { updateIsActiveStatus } from '../../../redux/actions/MasterDataAction/ProgramAction/programActions';
import { deleteMasterDataModule } from '../../../redux/actions/MasterDataAction/RecipeCollection/RecipeCollectionAction';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate, useSearchParams } from "react-router-dom";
import * as routes from "../../../Router/RoutesURL";
import { stableSort, getComparator, rowOptions, options, getPermissionByAppName, } from '../../../utils/Helper'
import './BlogsArticles.scss';
import { CircularProgress } from '@mui/material';
import { tabKeys } from '../../../Config/Constant';
import moment from 'moment';

const MainHeading = styled(Typography)(({ theme }) => ({
    color: theme.palette.primary.main,
}))

const headCells = [
    {
        id: 'title',
        width: '250px',
        disablePadding: true,
        label: 'TITLE',
    },
    {
        id: 'content_type',
        width: '200px',
        disablePadding: false,
        label: 'CONTENT TYPE',
    },
    {
        id: 'upload_by',
        width: '180px',
        disablePadding: false,
        label: 'UPLOADED BY',
    },
    {
        id: 'content_version',
        width: '160px',
        disablePadding: false,
        label: 'FREE / PAID',
    },
    {
        id: 'content_creation_datetime',
        width: '180px',
        disablePadding: false,
        label: 'CREATED ON',
    },
    {
        id: 'is_active',
        width: '120px',
        disablePadding: false,
        label: 'STATUS',

    },
    {
        id: 'action',
        width: '250px',
        disablePadding: false,
        label: 'ACTION',
        disableSorting: true
    },
];

const EnhancedTableHead = (props) => {
    const { order, orderBy, onRequestSort } =
        props;
    const createSortHandler = (property) => (event) => {
        onRequestSort(event, property);
    };

    return (
        <TableHead>
            <TableRow>
                {headCells.map((headCell) => (
                    <TableCell
                        key={headCell.id}
                        align='left'
                        padding={headCell.disablePadding ? 'none' : 'normal'}
                        sortDirection={orderBy === headCell.id ? order : false}
                        sx={{width: headCell.width, maxWidth: headCell.width}}
                    >
                        <TableSortLabel
                            active={orderBy === headCell.id && !headCell.disableSorting}
                            direction={orderBy === headCell.id ? order : "asc"}
                            onClick={!headCell.disableSorting ? createSortHandler(headCell.id) : undefined}
                            hideSortIcon={headCell.disableSorting}
                            disabled={headCell.disableSorting}
                            >
                            {headCell.label}

                            {orderBy === headCell.id && (
                                <Box component="span" sx={visuallyHidden}>
                                {order === "desc" ? "sorted descending" : "sorted ascending"}
                                </Box>
                            )}
                        </TableSortLabel>
                    </TableCell>
                ))}
            </TableRow>
        </TableHead>
    );
}

EnhancedTableHead.propTypes = {
    numSelected: PropTypes.number.isRequired,
    onRequestSort: PropTypes.func.isRequired,
    onSelectAllClick: PropTypes.func.isRequired,
    order: PropTypes.oneOf(['asc', 'desc']).isRequired,
    orderBy: PropTypes.string.isRequired,
    rowCount: PropTypes.number.isRequired,
};

const EnhancedTableToolbar = (props) => {
    const { activeTab, setShowLoader } = props;
    const [searchParams, setSearchParams] = useSearchParams();
    const [searchText, setSearchText] = useState(searchParams.get('searchText') || '');
    const dispatch = useDispatch();

    useEffect(() => {
        if (activeTab == tabKeys.contentManagement.ARTICLES) {
            setSearchText(searchParams.get('searchText') || '');
        }
    }, [activeTab, searchParams]);

    const handleChangeSearch = (e) => {
        setShowLoader(true)
        const newSearchText = e.target.value;
        setSearchText(newSearchText);

        // This part can be debounced for better performance
        const newParams = new URLSearchParams(searchParams);
        if (newSearchText) {
            newParams.set('searchText', newSearchText);
        } else {
            newParams.delete('searchText');
        }
        newParams.set('page', '1');
        setSearchParams(newParams, { replace: true });
    }
    return (

        <div>
            <Toolbar sx={{
                pl: { sm: 2 },
                pt: { sm: 2 },
                pb: { sm: 2 },
                pr: { xs: 1, sm: 1 },

            }}
            >
                <div className='col-2'>
                    <MainHeading
                        sx={{ flex: '1 1 100%', }}
                        variant="h6"
                        id="tableTitle"
                        component="div"
                    >
                        Content List
                    </MainHeading>
                </div>
                <div className='col-10 VideoLevelDiv'>
                    {/* <button type="button" className={filterAllBtn.join(' ')} onClick={() => { selectContentType(1) }}>All</button>
                    <button type="button" className={filterBlogsBtn.join(' ')} onClick={() => { selectContentType(2) }}>Blogs</button>
                    <button type="button" className={filterArticlesBtn.join(' ')} onClick={() => { selectContentType(3) }}>Articles</button>
                    <div className="separator"></div> */}
                    <div className="mr-sm-2 searchDiv class-search ">
                        <input
                            value={searchText}
                            className="form-control mr-sm-2 class-search"
                            type="search"
                            placeholder=" Search Keyword"
                            aria-label="Search"
                            onChange={handleChangeSearch}
                        ></input>
                    </div>
                </div>
            </Toolbar>
            <Divider />
        </div>
    );
}


const BlogsArticlesTable = (props) => {
    const { activeTab, permission } = props;
    const [searchParams, setSearchParams] = useSearchParams();
    const [order, setOrder] = useState(searchParams.get('order_by_type') || 'desc');
    const [orderBy, setOrderBy] = useState(searchParams.get('order_by') || 'content_creation_datetime');
    const [selected, setSelected] = useState([]);
    const [rowsPerPage, setRowsPerPage] = useState(parseInt(searchParams.get('limit')) || 10);
    const navigate = useNavigate()
    const [showConfirm, setShowConfirm] = useState(false);
    const [showConfirmDelete, setShowConfirmDelete] = useState(false);
    const [selectedContentView, setSelectedContentView] = useState("");
    const [viewContentsMainData, setViewContentsMainData] = useState('');
    const [showLoader, setShowLoader] = useState(false);
    const viewContentsDat = useSelector(state => state?.getContentsList);
    const loading = viewContentsDat.loadingBlogContent
    const {error} = viewContentsDat;
    const viewContentsDataRes = useSelector(state => state.getContentsList.blogContentList?.data);


    const dispatch = useDispatch();

    useEffect(() => {
        if (activeTab == tabKeys.contentManagement.ARTICLES) {
            const sendRequest = {
                "pageNo": searchParams.get('page') || 1,
                "pageSize": searchParams.get('limit') || 10,
                "filter_type": 1,
                "filter_text": searchParams.get('searchText') || '',
                "order": searchParams.get('order_by_type') || 'desc',
                "orderBy": searchParams.get('order_by') || 'content_creation_datetime',
                "category": 2
            };
            dispatch(getContentsList(sendRequest));
        }else{
            setOrder('desc');
            setOrderBy('content_creation_datetime');
            setRowsPerPage(10)
        }
    }, [activeTab, searchParams, dispatch]);

    useEffect(()=>{
        if(!loading && (viewContentsDataRes || error))
            setShowLoader(false)
        if(!loading && !viewContentsDataRes){
            setShowLoader(true)
        }
    }, [loading])

    useEffect(() => {
        if (viewContentsDat.error !== "No data found") {
            setViewContentsMainData(viewContentsDataRes && viewContentsDataRes?.content_data);
        } else {
            setViewContentsMainData('');
        }

    }, [viewContentsDataRes, viewContentsDat])

    const handleRequestSort = (event, property) => {
        const isAsc = orderBy === property && order === 'asc';
        const newOrder = isAsc ? 'desc' : 'asc';
        setOrder(newOrder);
        setOrderBy(property);
        const newParams = new URLSearchParams(searchParams);
        newParams.set('order_by_type', newOrder);
        newParams.set('order_by', property);
        setSearchParams(newParams, { replace: true });
    };

    const handleSelectAllClick = (event) => {
        if (event.target.checked) {
            const newSelected = viewContentsMainData.map((n) => n.name);
            setSelected(newSelected);
            return;
        }
        setSelected([]);
    };

    const handleClick = (event, name) => {
        const selectedIndex = selected.indexOf(name);
        let newSelected = [];

        if (selectedIndex === -1) {
            newSelected = newSelected.concat(selected, name);
        } else if (selectedIndex === 0) {
            newSelected = newSelected.concat(selected.slice(1));
        } else if (selectedIndex === selected.length - 1) {
            newSelected = newSelected.concat(selected.slice(0, -1));
        } else if (selectedIndex > 0) {
            newSelected = newSelected.concat(
                selected.slice(0, selectedIndex),
                selected.slice(selectedIndex + 1),
            );
        }
        setSelected(newSelected);
    };
    const handleChangePageNext = (newPage) => {
        setShowLoader(true)
        const nextPage = (viewContentsDataRes?.current_page_no || 0) + 1;
        const newParams = new URLSearchParams(searchParams);
        newParams.set('page', nextPage.toString());
        setSearchParams(newParams, { replace: true });
    };
    const handleChangePagePrev = (newPage) => {
        setShowLoader(true)
        const prevPage = (viewContentsDataRes?.current_page_no || 2) - 1;
        const newParams = new URLSearchParams(searchParams);
        newParams.set('page', prevPage.toString());
        setSearchParams(newParams, { replace: true });
    };

    const handleChangeRowsPerPage = (event) => {
        setShowLoader(true)
        const newRowsPerPage = parseInt(event.value, 10);
        setRowsPerPage(newRowsPerPage);
        const newParams = new URLSearchParams(searchParams);
        if (newRowsPerPage !== 10) {
            newParams.set('limit', newRowsPerPage.toString());
        } else {
            newParams.delete('limit');
        }
        newParams.set('page', '1');
        setSearchParams(newParams, { replace: true });
    };


    const handleChange = (contentId, type) => {
        if (permission === "write") {
            navigate(routes.ADD_BLOG_ARTICLE, { state: { contentId, selection: type } })
        } else {
            createNotification('warning', "Access Restricted");
        }
    };

    const handleViewContent = (id, data) => {
        navigate(routes.VIEW_BLOG_ARTICLE, { state: { id, path: "view", status: data.is_active, permission: permission } })
    };

    const cancelWarnModal = (e) => {
        setShowConfirm(false);
        setSelectedContentView("");
    };

    const handleDeleteContent = (id, data) => {
        if (permission === "write") {
            setShowConfirmDelete(true);
            setSelectedContentView(data);
        } else {
            createNotification('warning', "Access Restricted");
        }
    };

    const DeleteContent = () => {
        setShowConfirmDelete(false);
        const sendRequestDelete = {
            "feature_type": "content",
            "ids": selectedContentView.id,
            onSuccessCallback: ()=>{
                if(viewContentsDataRes?.start === viewContentsDataRes?.end){
                    const newParams = new URLSearchParams(searchParams);
                    newParams.set("page", (viewContentsDataRes?.current_page_no - 1 || 1));
                    setSearchParams(newParams, { replace: true });
                }else{
                    const sendRequest = {
                        "pageNo": viewContentsDataRes?.current_page_no || 1,
                        "pageSize": searchParams.get('limit') || 10,
                        "filter_text": searchParams.get('searchText') || '',
                        "filter_type": 1,
                        "category": 2
                    };
                    dispatch(getContentsList(sendRequest));
                    setShowConfirm(false);
                }
            }
        };
        dispatch(deleteMasterDataModule(sendRequestDelete));
    }



    const CancelDeleteModal = (e) => {
        setShowConfirmDelete(false);
        setSelectedContentView("");
    };

    const handleChangeOption = (e, id) => {
        if (permission === "write") {
            if (e.value === "Active") {
                viewContentsMainData.find(v => v.id === id).is_active = 1;
            } else {
                viewContentsMainData.find(v => v.id === id).is_active = 0;
            }
            setViewContentsMainData(viewContentsMainData)
            const sendRequest = {
                "feature_type": "content",
                "id": id,
                "status": e.value === "Active" ? 1 : 0
            };
            dispatch(updateIsActiveStatus(sendRequest));
        } else {
            createNotification('warning', "Access Restricted");
        }
    }


    return (
        <>
            <Box sx={{ width: '100%' }} className="BlogsBox h-100">
            <Paper  className='d-flex flex-column' sx={{ width: '100%', mb: 1, borderRadius: 2, height: 'calc(100% - 57px)' }}>
                    <EnhancedTableToolbar setShowLoader={setShowLoader} activeTab={activeTab} />
                    {
                        showLoader ?
                        <div className='w-100 py-5 text-center'>
                            <CircularProgress sx={{'color': '#74613C'}}/>
                        </div>
                        :
                        viewContentsDataRes && viewContentsMainData ? <TableContainer sx={{ pt: 0, pr: 3, pb: 3, pl: 3, height: '100%' }}>
                            <Table
                                sx={{ minWidth: 750, tableLayout: 'fixed'}}
                                aria-labelledby="tableTitle"
                                stickyHeader
                                size='small'
                            >
                                <EnhancedTableHead
                                    numSelected={selected.length} 
                                    order={order}
                                    orderBy={orderBy}
                                    onSelectAllClick={handleSelectAllClick}
                                    onRequestSort={handleRequestSort}
                                    rowCount={viewContentsDataRes && viewContentsDataRes?.content_data.length}
                                />
                                <TableBody>
                                    {
                                        viewContentsDataRes && viewContentsMainData
                                            .map((row, index) => {

                                                const labelId = `enhanced-table-checkbox-${index}`;
                                                return (
                                                    <TableRow hover onClick={(event) => handleClick(event, row.name)} role="checkbox"

                                                        tabIndex={-1}
                                                        key={row.id}

                                                    >
                                                        <TableCell align="left" padding="none" >
                                                            <p className='titleText othText'>
                                                                {row.title}

                                                            </p>
                                                        </TableCell>
                                                        <TableCell align="left"><p className='othText'>{row.content_type}</p></TableCell>
                                                        <TableCell align="left">
                                                            <p className='othText'>
                                                                {row.upload_by}</p></TableCell>
                                                        <TableCell align="left"
                                                        ><p className='othText'>{row.content_version}</p>
                                                        </TableCell>
                                                        <TableCell align="left"
                                                        ><p className='othText'>{moment(row.content_creation_datetime).format('DD/MM/YYYY')}</p>
                                                        </TableCell>
                                                        <TableCell align="left" width="10px" sx={{ color: row.is_active == 1 ? '#000000' : "#AAAAAA" }}>
                                                            <Select
                                                                className="react-select status-select"
                                                                classNamePrefix="react-select"
                                                                onChange={(e) => { handleChangeOption(e, row.id) }}
                                                                value={row.is_active === 1 ? { label: "Active", value: "Active" } : { label: "Inactive", value: "Inactive" }}
                                                                options={options}
                                                                isSearchable={false}
                                                                menuPlacement="auto"
                                                                menuPosition="absolute"   
                                                                menuPortalTarget={null}
                                                                theme={(theme) => ({
                                                                    ...theme,
                                                                    isFocused: "#74613C",
                                                                    colors: {
                                                                        ...theme.colors,
                                                                        primary25: '#F5F5F5',
                                                                        primary: '#f6f4f0',

                                                                    },
                                                                })}
                                                                getOptionLabel={(row) => (
                                                                    <><span className={row.label === "Active" ? "ActiveClass" : "InactiveClass"}
                                                                    >
                                                                        {row.label}
                                                                    </span>
                                                                        {row.is_active === 1 && (
                                                                            <div
                                                                            ></div>
                                                                        )}
                                                                    </>
                                                                )}
                                                            />
                                                        </TableCell>
                                                        <TableCell align="left">
                                                            <ul className="list-group d-flex flex-row ">
                                                                <li
                                                                    className={row.is_active == 1 ? 'list-group-item ViewEditClick p-0 ' : "list-group-item ViewEditNotClick p-0"}
                                                                    onClick={row.is_active == 1 ? () => { handleViewContent(row.id, row) } : ""}><i className="fas fa-eye mr-1"></i> View</li>
                                                                {
                                                                    getPermissionByAppName("Content Management") === "write" &&
                                                                    <>
                                                                        <li className={row.is_active == 1 ? 'list-group-item ViewEditClick p-0 ' : "list-group-item ViewEditNotClick p-0"} onClick={row.is_active == 1 ? () => { handleChange(row.id, "edit") } : ""} ><i className="fa fa-pen mr-1"></i> Edit</li>
                                                                        <li className="list-group-item Delete p-0" onClick={() => { handleDeleteContent(row.id, row) }}><i className="fa fa-trash mr-1"></i> Delete</li>
                                                                    </>
                                                                }
                                                            </ul>
                                                        </TableCell>
                                                    </TableRow>
                                                );
                                            })}
                                </TableBody>
                            </Table>
                        </TableContainer>
                        : <div className='text-center w-100 text-muted mt-3'>No Records</div>
                    }
                </Paper>
                {
                    viewContentsMainData &&
                    <div className='paginationBlock'>
                        <div className='textData'><p>Items per page: </p></div>
                        <FormGroup className="FormGroup has-float-label rowsSelect class-menu-dropdown ">
                            <Select
                                placeholder={rowsPerPage}
                                className="react-select"
                                classNamePrefix="react-select"
                                value={rowsPerPage}
                                options={rowOptions}
                                menuPlacement="top"
                                menuPosition="fixed"
                                isSearchable={false}
                                onChange={handleChangeRowsPerPage}
                                theme={(theme) => ({
                                    ...theme,
                                    colors: {
                                        ...theme.colors,
                                        primary25: '#F5F5F5',
                                        primary: '#74613C',
                                    },
                                })}
                            />
                        </FormGroup>
                        {viewContentsDataRes?.content_data && <p className='endText'>   {viewContentsDataRes?.start} - {viewContentsDataRes?.end} of {viewContentsDataRes?.total}</p>}
                        <p>
                            
                            <button className={`btnPrev ${viewContentsDataRes?.current_page_no === 1 ? "opacityBtns" : ''}`} disabled={viewContentsDataRes?.current_page_no === 1} onClick={() => { handleChangePagePrev() }}>
                                <ArrowBackIosNewSharpIcon className='iconBtn' />
                            </button> 
                            <button className={`btnPrev ${viewContentsDataRes?.current_page_no === viewContentsDataRes?.total_pages ? "opacityBtns" : ''}`} disabled={viewContentsDataRes?.current_page_no === viewContentsDataRes?.total_pages} onClick={() => { handleChangePageNext() }}>
                                <ArrowForwardIosSharpIcon className='iconBtn' />
                            </button></p>
                    </div>
                }
            </Box>

            <Modal centered className="viewContent-modal-warning br-8" show={showConfirm} onHide={() => { setShowConfirm(false) }}>
                <form className=""
                >
                    <Modal.Header>
                        <div className="modalText pb-4">{selectedContentView.title}</div>
                        <Select
                            className={selectedContentView.is_active === 1 ? "react-select" : "react-selectChange"}
                            classNamePrefix="react-select"
                            onChange={(e) => { handleChangeOption(e, selectedContentView.id) }}
                            value={selectedContentView.is_active === 1 ? { label: "Active", value: "Active" } : { label: "Inactive", value: "Inactive" }}
                            options={options}
                            theme={(theme) => ({
                                ...theme,
                                isFocused: "#74613C",
                                colors: {
                                    ...theme.colors,
                                    primary25: '#F5F5F5',
                                    primary: '#f6f4f0',

                                },
                            })}
                            getOptionLabel={(row) => (
                                <><span className={row.label === "Active" ? "ActiveClass" : "InactiveClass"}
                                >
                                    {row.label}
                                </span>
                                    {row.is_active === 1 && (
                                        <div

                                        ></div>
                                    )}
                                </>
                            )}
                        />
                    </Modal.Header>
                    <Modal.Body>
                        <div className="modalData">
                            <div className='imgDivContent'>
                                <video className="videoShow" width="600" height="240" controls>
                                    <source src="myvid.mp4" type="video/mp4" />
                                    <source src="myvid.ogg" type="video/ogg" />
                                </video>
                            </div>
                            <div className='dataContent'>
                                <div className='firstCol'>
                                    <div className='titleTextData'><p className='headeTitle'>Category:</p><p>{selectedContentView.content_category}</p></div>
                                    <div className='titleTextData'><p className='headeTitle'>Type:</p><p>On Demand</p></div>
                                </div>
                                <div className='secondCol'>
                                    <div className='titleTextData'><p className='headeTitle'>Duration:</p><p>{selectedContentView.duration}</p></div>
                                    <div className='titleTextData'><p className='headeTitle'>Free / Paid:</p>
                                        {selectedContentView.content_version !== "free" ?
                                            <div className='contentTypeText'>
                                                <p className='othText'>{selectedContentView.content_version}</p>
                                                <p className='rupeesText'>- ₹{selectedContentView.amount}</p></div> : <p className='othText'>{selectedContentView.content_version}</p>}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <button type="button" className="btn btn-danger redButton mr-3" onClick={cancelWarnModal}>
                            <img className="mainIcon mr-2" src={redCross} alt="" width="16px" height="16px" />
                            CLOSE</button>
                    </Modal.Footer>
                </form>
            </Modal>
            <Modal centered className="TeamMember-modal-warning br-8" show={showConfirmDelete} onHide={() => { setShowConfirmDelete(false) }}>
                <Modal.Header>
                    <div className="modalText pb-4">Are you sure?</div>
                </Modal.Header>
                <Modal.Body>
                    <div className="">
                        <label htmlFor="exampleFormControlInput1" className="form-label DeleteDesc">You want to delete this record?</label>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <button type="button" className="btn btn-success greenButton mr-3" onClick={CancelDeleteModal}>
                        Cancel</button>
                    <button type="button" className="btn btn-danger redButton " onClick={DeleteContent}>
                        Delete</button>
                </Modal.Footer>
            </Modal>
        </>

    );
}
export default BlogsArticlesTable
